import type { ParamMatcher } from '@sveltejs/kit';
import { locales, type Locale } from '../locales/data.js';

export const match = ((param: string): param is Exclude<Locale, 'en'> => {
	if (param === 'en') {
		return false;
	}
	return locales.includes(param as Locale);
}) satisfies ParamMatcher;
